module.exports = __webpack_public_path__ + "static/media/vbn-picture-5.d8c76f26.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Themes/VBN/vbn-picture-5.jpg
// module id = 582
// module chunks = 0